<template>
  <div class="mall-cart-summary" :class="{ 'mall-cart-summary--expanded': expanded }">
    <div class="mall-cart-summary__body">
      <div class="mall-cart-summary__head" @click="expanded = !expanded">
        <img
          v-if="expanded"
          class="mall-cart-summary__caret"
          src="@/assets/mall/icn_caret_down.svg"
          alt="접기"
        />
        <img
          v-else
          class="mall-cart-summary__caret mall-cart-summary__caret--up"
          src="@/assets/mall/icn_chevron_right_small.svg"
          alt="펼치기"
        />
        <div class="mall-cart-summary__total">
          <span class="mall-cart-summary__total-label">총 {{ count }}건 결제 예정금액</span>
          <span class="mall-cart-summary__total-price">{{ formatPrice(payAmount) }}</span>
        </div>
      </div>

      <template v-if="expanded">
        <div class="mall-cart-summary__divider"></div>
        <div class="mall-cart-summary__details">
          <template v-for="(row, index) in details">
            <!-- 하위 항목 묶음 (좌측 세로선) -->
            <div v-if="row.children" :key="'group-' + index" class="mall-cart-summary__group">
              <div class="mall-cart-summary__group-line"></div>
              <div class="mall-cart-summary__group-rows">
                <div v-for="child in row.children" :key="child.label" class="mall-cart-summary__row">
                  <span class="mall-cart-summary__label">{{ child.label }}</span>
                  <span class="mall-cart-summary__value mall-cart-summary__value--accent">{{ child.value }}</span>
                </div>
              </div>
            </div>
            <div v-else :key="row.label" class="mall-cart-summary__row">
              <span class="mall-cart-summary__label">{{ row.label }}</span>
              <span class="mall-cart-summary__value">{{ row.value }}</span>
            </div>
          </template>
        </div>
      </template>
    </div>

    <div class="mall-cart-summary__buttons">
      <MallButton :label="'상품 결제하기'" :type="'primary'" :disabled="payDisabled" @click="$emit('pay')" />
    </div>
  </div>
</template>

<script>
import convert from '@/utilities/convert.js'
import MallButton from '@/components/new/atoms/MallButton.vue'

export default {
  name: 'MallCartSummary',
  components: {
    MallButton,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
    payAmount: {
      type: Number,
      required: true,
    },
    // [{ label, value }] 또는 하위 묶음 [{ children: [{ label, value }] }]
    details: {
      type: Array,
      default: () => [],
    },
    payDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    formatPrice(price) {
      return convert.setComma(price) + '원'
    },
  },
}
</script>

<style scoped>
.mall-cart-summary {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 600px;
  filter: drop-shadow(0 -1px 12px rgba(24, 24, 28, 0.11));
  z-index: 10;
}

.mall-cart-summary--expanded {
  filter: drop-shadow(0 -1px 12px rgba(24, 24, 28, 0.19));
}

.mall-cart-summary__body {
  display: flex;
  padding: 8px 16px 0 16px;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px 12px 0 0;
  background: #FFF;
}

.mall-cart-summary--expanded .mall-cart-summary__body {
  padding-bottom: 16px;
}

.mall-cart-summary__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  cursor: pointer;
}

.mall-cart-summary__caret {
  display: block;
}

.mall-cart-summary__caret--up {
  transform: rotate(-90deg);
}

.mall-cart-summary__total {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-cart-summary__total-label {
  color: #6B7684;
}

.mall-cart-summary__total-price {
  color: var(--color-text-main);
  text-align: right;
}

.mall-cart-summary__divider {
  height: 1px;
  background: #F2F4F6;
}

.mall-cart-summary__details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mall-cart-summary__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-cart-summary__label {
  color: #6B7684;
}

.mall-cart-summary__value {
  color: #4E5968;
  text-align: right;
}

.mall-cart-summary__value--accent {
  color: #0096FF;
}

.mall-cart-summary__group {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.mall-cart-summary__group-line {
  flex-shrink: 0;
  width: 2px;
  margin: 4px 0;
  border-radius: 10000px;
  background: #E5E8EB;
}

.mall-cart-summary__group-rows {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.mall-cart-summary__buttons {
  display: flex;
  padding: 20px 16px 16px 16px;
  background: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallCartSummary.vue